import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import BackendQuery from "decentralized/BackendQuery.js";
import {sleep} from "utils/sleep.js"
import ZProjectsContract from 'decentralized/contracts/ZProjectsContract.js';
import {
    SampleInSequence,
    ProjectUsesPreset,
    ProjectPatternsCount,
    ProjectVisuals,
    ProjectBPM,
    ProjectHasArrangement
} from "decentralized/EthereumEvents.js"
import ProjectMetadataContract from "decentralized/contracts/ProjectMetadataContract.js";
import {PROJECT_METADATA} from 'decentralized/transactions/contracts.js';
import {web3} from 'decentralized/web3.js';
import EthereumTransaction from "decentralized/transactions/EthereumTransaction.js";
import ipfs from 'decentralized/Ipfs.js';

let contract = new ProjectMetadataContract();

export const saveProjectMetadata = async ({
    projectHash,
    bpm,
    hasArrangement,
    thumbnail,
    presetsList,
    patterns
}) => {
    console.log("generated project metata=", thumbnail, projectHash, bpm, hasArrangement, presetsList, patterns);
    projectHash = ipfsHashToBytes32(projectHash);
    let nullBytes32 = web3.utils.padLeft('0x0', 64);
    thumbnail = thumbnail ? ipfsHashToBytes32(thumbnail) : nullBytes32;
    presetsList = presetsList.map(
        presetHash => ipfsHashToBytes32(presetHash));

    new EthereumTransaction(
        PROJECT_METADATA,
        'newProjectMetadata',
        [
            projectHash,
            bpm,
            thumbnail,
            presetsList,
            patterns,
            hasArrangement
        ])
        .execute();
        
};

export const generateProjectMetadata = async (engine, projectHash) => {
    // returns the obj used by saveProjectMetadata from an instance of engine
    let presetsList = engine.subSequences.flatMap(
        sub => sub.tracks.filter(x => x.preset && x.preset.contentHash)
            .map(x => x.preset.contentHash));

    let patterns = engine.tracks[0] ? engine.tracks[0].patterns.length : 0;
    let hasArrangement = engine.subSequences[0].mix && engine.subSequences[0].mix.length > 0;
    let bpm = engine.bpm;


    let thumbnail = undefined;
    let canvas = engine.subSequences[0].findNodeByName("three.canvas").find(
        x => !x.isUI && (!x.subSequence.zObject || !x.subSequence.zObject.isUI));
    if (canvas && canvas.effect.renderer) {
        console.log("generating thumbnail with canvas=", canvas);
        let dataURL = canvas.effect.renderer.domElement.toDataURL().slice(22);
        var imageBuffer = Buffer.from(dataURL, "base64");
        thumbnail = await ipfs.addBuffer(imageBuffer);
    }
    
    return {
        bpm,
        thumbnail,
        projectHash,
        hasArrangement,
        patterns,
        presetsList
    };
};

export const getProjectMetadatas = async (projectHashes, includeSamples=true) => {
    let thumbQuery = new BackendQuery(contract.contractAddress)
        .from(ProjectVisuals)
        .select("projectHash")
        .select("thumbnailhash")
        .whereIn("projectHash", projectHashes);

    let thumbResults = await thumbQuery.executeQuery();

    let presetsQuery = new BackendQuery(contract.contractAddress)
        .from(ProjectUsesPreset)
        .select("projectHash")
        .select("presetHash")
        .whereIn("projectHash", projectHashes);

    let presetResults = await presetsQuery.executeQuery();

    let arrangementQuery = new BackendQuery(contract.contractAddress)
        .from(ProjectHasArrangement)
        .select("projectHash")
        .whereIn("projectHash", projectHashes);

    let arrangementResults = await arrangementQuery.executeQuery();

    let results = {};
    if (includeSamples) {
        let samplesQuery = new BackendQuery(new ZProjectsContract().contractAddress)
            .from(SampleInSequence)
            .select("sequenceHash")
            .select("sampleHash")
            .whereIn("sequencehash", projectHashes);
        let sampleResults = await samplesQuery.executeQuery();
        
        for (let sampleResult of sampleResults) {
            let {sequenceHash, sampleHash} = sampleResult;
            if (!results[sequenceHash]) {
                results[sequenceHash] = {};
            }
            if (!results[sequenceHash].samples) {
                results[sequenceHash].samples = [];
            }
            results[sequenceHash].samples.push(sampleHash);
        }
    }

    for (let thumbResult of thumbResults) {
        let {projectHash, thumbnailhash} = thumbResult;
        if (!results[projectHash]) {
            results[projectHash] = {};
        }
        results[projectHash].thumbnail = thumbnailhash;
    }

    for (let presetResult of presetResults) {
        let {projectHash, presetHash} = presetResult;
        if (!results[projectHash]) {
            results[projectHash] = {};
        }
        if (!results[projectHash].presets) {
            results[projectHash].presets = [];
        }
        results[projectHash].presets.push(presetHash);
    }

    for (let arr of arrangementResults) {
        let {projectHash} = arr;
        if (!results[projectHash]) {
            results[projectHash] = {};
        }
        results[projectHash].hasArrangement = true;
    }

    console.log("RESULTS=", results);

    return results;
};

export const checkIfMetadataExists = async (engine) => {
    await sleep(1000);
    if (!engine.sequenceId) {
        return;
    }
    let results = await getProjectMetadatas([engine.sequenceId], false);
    if (Object.keys(results).length > 0) {
        return;
    }

    let meta = await generateProjectMetadata(engine, engine.sequenceId);
    saveProjectMetadata(meta);
};
 
